import { DOCUMENT_UPLOAD_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/DocumentUploadForm/documentUploadFormDefaults";
import type { DocumentUploadFormInput } from "web_myplann/Portfolio/Forms/DocumentUploadForm/documentUploadFormSchema";
import type { DocumentUploadOrigin } from "web_myplann/Portfolio/Helpers/documentUploadOrigin";

export const mapOriginToDocumentUploadForm = (
	origin: DocumentUploadOrigin,
): DocumentUploadFormInput => ({
	...DEFAULTS,
	folder: origin.folder ?? DEFAULTS.folder,
});
